import { Component, Injector, OnInit, computed, forwardRef, input, model, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { AbstractControl, ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { DxCheckBoxComponent, DxCheckBoxModule } from 'devextreme-angular';
import { ValueChangedEvent } from 'devextreme/ui/check_box';
import { LayoutHorizontalControlComponent } from '../../internal/layout-horizontal-control/layout-horizontal-control.component';
import { ControlLabelComponent } from '../../internal/control-label/control-label.component';
import { ControlSupportingTextComponent } from '../../internal/control-supporting-text/control-supporting-text.component';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true
    }
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LayoutHorizontalControlComponent, ControlLabelComponent, DxCheckBoxModule, ControlSupportingTextComponent]
})
export class CheckboxComponent implements OnInit, ControlValueAccessor {
  private dx = viewChild.required<DxCheckBoxComponent>('dx');
  ngControl: NgControl = null;

  caption = input.required<string>();
  value = model<boolean>(false);
  helpText = input<string>();
  readonly = input<boolean>(false);

  computedValue = computed(() => !!this.value());

  constructor(private injector: Injector) {
  }

  ngOnInit(): void {
    this.ngControl = this.injector.get(NgControl);
  }

  get control(): AbstractControl {
    return this.ngControl?.control;
  }

  onValueChanged(e: ValueChangedEvent): void {
    if (e.value !== this.computedValue()) {
      this.onChanged(e.value);
      this.value.set(e.value);
    }
  }

  onBlur($event: any) {
    this.onTouched();
  }

  /*
   * ControlValueAccessor interface methods
   */

  writeValue(obj: any): void {
    this.value.set(obj);
  }

  onChanged: (value: any) => void = () => { };
  registerOnChange(fn: any): void {
    this.onChanged = fn;
  }

  onTouched: () => void = () => { };
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.dx().disabled = isDisabled;
  }

}
